import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import React from 'react'; 

function ResetOnSignalPlugin({ resetSignal }) {
  const [editor] = useLexicalComposerContext();
  const prev = React.useRef(resetSignal);

  React.useEffect(() => {
    if (prev.current !== resetSignal) {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
      });
      prev.current = resetSignal;
    }
  }, [resetSignal, editor]);

  return null;
}

export default ResetOnSignalPlugin; 